import React, { useContext, useEffect, useState } from "react";
import ManageLicensesPack from "./components/manageLicensesPack";
import Loader from "../../../lib/ui/loader/Loader";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import NoLicenses from "./components/noLicenses";
import "./styles.css";
import "../Styles.css";
import { getLicense } from "../../../actions/licenseManagement";

const ManageLicense = () => {
    const { l } = useContext(LangCtx);
    const [licenseData, setLicenseData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { payload } = useContext(PayLoadCtx);

    useEffect(() => {
        getLicenseData();
    }, []);

    const getLicenseData = () => {
        setLoading(true);
        getLicense(payload?.userId)
            .then((res) => {
                setLoading(false);
                if (res.status) {
                    setLicenseData(res.result);
                } else {
                    setLicenseData(null);
                }
            })
            .catch((err) => {
                setLoading(false);
                setLicenseData(null);
                console.log("err ==== ", err);
            });
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <div className="baseContainer">
                <div className="mainContainer fullHeight">
                    <div className="flexCol respdngLG alignCntr">
                        <div className="flexCol rescenterCntnr">
                            <div className="flexRow mrgnBtmMD">
                                <h2 className="topHdngTxt">{l.manage_licenses}</h2>
                            </div>
                            <div className="flexCol">
                                {licenseData !== null && licenseData?.to >= new Date().valueOf() ? (
                                    <>
                                        <div className="flexCol newCard vrtclCard">
                                            <ManageLicensesPack licenseData={licenseData} />
                                        </div>
                                    </>
                                ) : (
                                    <NoLicenses />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ManageLicense;
